import PMSRoutes from './routes/pmsRoutes';
import '../src/utils/Global.css';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { updateActiveTab } from './redux/employee/EmployeeSlice';
import { updateActiveTabPro, updateIsManager } from './redux/project/ProjectSlice';
import { updateLmsTab } from './redux/lms/LmsSlice';
import { updateHmsTab, updateInternalHmsTab } from './redux/hms/HmsSlice';
import { updateRequestTab } from './redux/request/RequestSlice';
import { updateNotificationTab } from './redux/notification/NotificationSlice';
import { ThemeProvider } from '@emotion/react';
import { adminTheme, userTheme } from './theme/themeComponent';

function App() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isEmployee } = useSelector((e) => e.userInfo);

  useEffect(() => {
    if (!location.pathname.includes('view-employee')) {
      dispatch(updateActiveTab('General Info'));
    }
    if (!location.pathname.includes('project/details')) {
      dispatch(updateActiveTabPro('General Info'));
      dispatch(updateIsManager(false));
    }
    if (!location.pathname.includes('lms')) {
      dispatch(updateLmsTab('today'));
    }
    if (!location.pathname.includes('requests')) {
      dispatch(updateRequestTab('upcoming'));
    }
    if (!location.pathname.includes('hms')) {
      dispatch(updateHmsTab('Inventory'));
      dispatch(updateInternalHmsTab('Hardware Info'));
    }
    if (!location.pathname.includes('notification') && !isEmployee) {
      dispatch(updateNotificationTab('Sent'));
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!isEmployee) {
      document.documentElement.setAttribute('data-theme', 'dark');
    } else {
      document.documentElement.setAttribute('data-theme', 'light');
    }
  }, [isEmployee]);

  return (
    <ThemeProvider theme={isEmployee ? userTheme : adminTheme}>
      <PMSRoutes />
    </ThemeProvider>
  );
}

export default App;
